import styled, { css } from 'styled-components'

export const SelectWrap = styled.div`
  width: 100%;
  position: relative;

  ${(p) =>
    p.type === 'inline' &&
    css`
      display: flex;
      align-items: center;
      grid-gap: 15px;
    `}

  ${({ $selectTheme }) =>
    $selectTheme === 'read-only' &&
    css`
      .Select__control {
        background-color: var(--t-checkbox-custom-disable-bg);
        border-color: var(--t-checkbox-custom-disable-bg);
      }
      .Select__single-value {
        color: var(--t-select-read-only-color);
      }
      .Select__indicator {
        color: var(--t-select-read-only-color);
      }
    `}

  &.has-error {
    .Select__control {
      ${(p) =>
        p.$selectTheme === 'bottom-line'
          ? css`
              border: none;
              border-bottom: 1px solid var(--t-input-has-error);
              background-color: transparent;
            `
          : css`
              border-color: var(--t-input-has-error);
              background-color: var(--t-input-has-error);
            `}
    }

    &:not(.has-label) {
      .errorIcon,
      .successIcon {
        top: 21px;
      }
    }
  }

  ${(p) =>
    p.$noMargin
      ? ``
      : `&:not(:last-child) {
    margin-bottom: 28px;
  }`}

  .errorIcon,
  .successIcon {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    pointer-events: none;
  }
`

export const SelectLabel = styled.div`
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  line-height: 15px;
  color: var(--t-text-label);

  ${(p) =>
    p.type === 'inline' &&
    css`
      margin: 0px;
    `}

  span {
    color: var(--t-forms-label-span-text);
  }
`

export const OptionText = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 98%;
  padding-left: 4px;
`

export const SelectError = styled.div`
  color: var(--t-input-text-error);
  font-size: 11px;
  font-weight: 500;
  line-height: 14px;
  margin-top: 5px;
`
